import {CoachingReview} from 'records/CoachingPlan';
// TODO rename all imports to point to new location, this is just
// a bandaid to keep things working. Intellij has no way to change
// a default export to a non-default one
export default CoachingReview;
